import { render, staticRenderFns } from "./InstanceList.vue?vue&type=template&id=ba06e06c"
import script from "./InstanceList.vue?vue&type=script&lang=js"
export * from "./InstanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports